import { render, staticRenderFns } from "./x-textarea.vue?vue&type=template&id=e7c190ee&scoped=true&"
import script from "./x-textarea.vue?vue&type=script&lang=js&"
export * from "./x-textarea.vue?vue&type=script&lang=js&"
import style0 from "./x-textarea.vue?vue&type=style&index=0&id=e7c190ee&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c190ee",
  null
  
)

export default component.exports